const _require = require(/* configBehaviorIgnore: true */'../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evaluate - evaluate getHullJobsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const hullID = await evaluateSource(source.hullID, content, parentContentPath, transientContext, nativeFunctions);
  if (hullID === undefined) {
    return undefined;
  }
  const formQuerySource = {
    type: 'queryEntityBehavior',
    entityName: 'Form',
    properties: ['id'],
    equals: {
      'formType/identifier': 'job'
    },
    ifContent: {
      atAnyPaths: ["/headerDetails/hull/".concat(hullID, "/_formRef"), '/headerDetails/hull/id'],
      equals: hullID
    }
  };
  const forms = await evaluateSource(formQuerySource, content, parentContentPath, transientContext, nativeFunctions);
  const formIDs = forms.map(form => form.id);
  const jobQuerySource = {
    type: 'queryEntityBehavior',
    entityName: 'Job',
    properties: ['id'],
    equalsOneOf: {
      'form/id': formIDs
    }
  };
  const jobs = await evaluateSource(jobQuerySource, content, parentContentPath, transientContext, nativeFunctions);
  const jobIDs = jobs.map(job => job.id);
  return jobIDs;
};
module.exports = {
  evaluate
};